// src/components/atoms/utilities/Space.tsx
import React from "react";

/**
 * Space is a utility component that adds space between elements.
 * @param {number} size - Specify the size of the space (default is 8px)
 */
interface SpaceProps {
  size?: number; // Specify the size of the space (default is 8px)
}

/**
 * Space is a utility component that adds space between elements.
 * @param {number} size - Specify the size of the space (default is 8px)
 * @returns {JSX.Element} Space component
 */
const Spacer: React.FC<SpaceProps> = ({ size = 8 }) => {
  return <div style={{ margin: `${size}px 0` }} />;
};

export default Spacer;
